import React from "react";
import {
  Badge,
  Card,
  CardBody,
  CardHeader,
  HStack,
  Heading,
  SkeletonText,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import EmptyState from "./EmptyState";

const InvoicesTable = ({ invoices, isLoading, formatCurrency, formatDateTime, statusColor }) => {
  return (
    <Card variant="outline" _hover={{ boxShadow: "md" }} transition="box-shadow 0.2s ease">
      <CardHeader>
        <HStack justify="space-between">
          <Heading size="sm">All Invoices</Heading>
          <Text fontSize="sm" color="gray.500">
            {invoices.length} records
          </Text>
        </HStack>
      </CardHeader>
      <CardBody>
        {isLoading ? (
          <SkeletonText noOfLines={6} spacing="3" />
        ) : invoices.length === 0 ? (
          <EmptyState title="No invoices yet" description="Create an invoice to start tracking payments." />
        ) : (
          <TableContainer>
            <Table size="sm">
              <Thead>
                <Tr>
                  <Th>Invoice</Th>
                  <Th>Customer</Th>
                  <Th isNumeric>Amount</Th>
                  <Th>Status</Th>
                  <Th>Created</Th>
                  <Th>Due</Th>
                  <Th>Paid</Th>
                </Tr>
              </Thead>
              <Tbody>
                {invoices.map((invoice) => (
                  <Tr key={invoice.id}>
                    <Td>{invoice.invoiceNumber || `#${invoice.id}`}</Td>
                    <Td>{invoice.customerEmail}</Td>
                    <Td isNumeric>{formatCurrency(invoice.amount, invoice.currency)}</Td>
                    <Td>
                      <Badge colorScheme={statusColor(invoice.status)}>{invoice.status}</Badge>
                    </Td>
                    <Td>{formatDateTime(invoice.createdDate)}</Td>
                    <Td>{formatDateTime(invoice.dueDate)}</Td>
                    <Td>{formatDateTime(invoice.paidDate)}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        )}
      </CardBody>
    </Card>
  );
};

export default InvoicesTable;
